export const imageArray = [
  "https://i.ibb.co/VQV56gT/slider1.jpg",
  "https://i.ibb.co/v1r6f53/slider2.jpg",
  "https://i.ibb.co/98KtKjM/slider3.jpg",
];
